"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactPhoneNumberInput = _interopRequireWildcard(require("react-phone-number-input"));
require("react-phone-number-input/style.css");
var _Translations = require("./Translations");
var _core = require("@material-ui/core");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    root: {
      '& > .react-phone-number-input__row': {
        padding: 12
      }
    }
  };
};
var PhoneNumberInput = /*#__PURE__*/function (_React$Component) {
  _inherits(PhoneNumberInput, _React$Component);
  var _super = _createSuper(PhoneNumberInput);
  function PhoneNumberInput(props) {
    var _this;
    _classCallCheck(this, PhoneNumberInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "changeValue", function (value) {
      _this.setState({
        value: value
      });
      _this.validateNumber(value);
    });
    _defineProperty(_assertThisInitialized(_this), "validateNumber", function (value) {
      if ((0, _reactPhoneNumberInput.isValidPhoneNumber)(value)) {
        _this.setState({
          isValid: true
        });
      } else {
        _this.setState({
          isValid: false
        });
      }
    });
    _this.state = {
      value: _this.props.value,
      isValid: false
    };
    return _this;
  }
  _createClass(PhoneNumberInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateNumber(this.props.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          value: this.props.value
        });
        this.validateNumber(this.props.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        value = _this$state.value,
        isValid = _this$state.isValid;
      var _this$props = this.props,
        name = _this$props.name,
        _onChange = _this$props.onChange,
        country = _this$props.country,
        placeholder = _this$props.placeholder,
        intl = _this$props.intl,
        errored = _this$props.errored,
        classes = _this$props.classes;
      var error = value && value !== "" && (isValid ? undefined : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Invalid phone number",
        defaultMessage: "Invalid phone number"
      }));
      var importedProps = _lodash.default.pick(this.props, [
      // 'placeholder',
      'required']);
      return /*#__PURE__*/_react.default.createElement(_reactPhoneNumberInput.default, _extends({}, importedProps, {
        placeholder: intl.formatMessage({
          id: placeholder,
          defaultMessage: placeholder
        }),
        name: name,
        className: "phone-component ".concat(classes.root),
        onChange: function onChange(value) {
          _this2.changeValue(value);
          _onChange && (0, _reactPhoneNumberInput.isValidPhoneNumber)(value) && _onChange({
            target: {
              name: name,
              type: 'text',
              value: value
            }
          });
        },
        value: value,
        error: errored || error,
        country: country || "DZ"
      }));
    }
  }]);
  return PhoneNumberInput;
}(_react.default.Component);
var _default = (0, _reactIntl.injectIntl)((0, _core.withStyles)(styles)(PhoneNumberInput));
exports.default = _default;